var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"add-seal"},[_c('div',{staticClass:"from"},[_c('a-form-model-item',{attrs:{"label":"印章名称："}},[_c('a-input',{attrs:{"placeholder":"请输入印章名称"}})],1),_c('a-button',[_vm._v("Default")])],1),_c('div',{staticClass:"view"},[_vm._v("dsadsa")])])
}
var staticRenderFns = []

export { render, staticRenderFns }